import {connect} from "react-redux";
import AccessRight from "./AccessRight";
import {compose} from "redux";
import {WithAppendHeaderAndFooterHOC} from "../../HOC/WithAppendHeaderAndFooterHOC";
import {WithAppendSidebarHOC} from "../../HOC/WithAppendSidebarHOC";
import {getObjectsSelector} from "../Objects/selectors";
import {WithModeratorSearchHOC} from "../../HOC/WithModeratorSearchHOC";


let mapStateToProps = (state) => {
    return {
        objects: getObjectsSelector(state),
    }
};



export default compose(connect(mapStateToProps, {}), WithAppendHeaderAndFooterHOC, WithAppendSidebarHOC, WithModeratorSearchHOC)(AccessRight);



